/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestSnapshotDelegateRegistry extends Contract<ITestSnapshotDelegateRegistry> {
  delegation: Call<(_delegator: AddressLike, _id: BytesLike) => string, ITestSnapshotDelegateRegistry>
  'delegation(address,bytes32)': Call<(_delegator: AddressLike, _id: BytesLike) => string, ITestSnapshotDelegateRegistry>
}

let ITestSnapshotDelegateRegistryBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestSnapshotDelegateRegistryBytecode = '0x';
}

// prettier-ignore
export const ITestSnapshotDelegateRegistry = contract<ITestSnapshotDelegateRegistry>(ITestSnapshotDelegateRegistryBytecode)`
  function delegation(address _delegator, bytes32 _id) view returns (address delegate_)
`;